import type { ClientUiPublic } from '../api/platformConfig'

/**
 * 未成功拉取 `/v1/platform-configs` 时的占位状态：不臆造模型或尺寸列表，与后端 catalog 单一事实来源对齐。
 */
export const EMPTY_CLIENT_UI: ClientUiPublic = {
  maxImagesPerRequest: 1,
  textModels: [],
  imageModels: [],
  imageSizeOptions: [],
  referenceSuperResolutionAvailable: false,
}
